import React from 'react';
import Flatpickr from 'react-flatpickr';
// import 'flatpickr/dist/themes/material_blue.css';
import 'flatpickr/dist/themes/material_blue.css';
import { CalendarIcon } from 'lucide-react';

interface DatePickerProps {
  label?: string;
  value: Date | string;
  onChange: (date: Date) => void;
  placeholder?: string;
  className?: string;
  width?: string;
  classContainer?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  value,
  onChange,
  placeholder = 'Select date',
  className = '',
  width = 'w-full',
  classContainer = '',
}) => {
  return (
    <div className={`flex flex-col gap-1 ${width} ${classContainer}`}>
      {label && <label className="text-sm font-medium text-[#143887]">{label}</label>}
      <div className="relative w-full">
        <Flatpickr
          value={value}
          onChange={([selectedDate]) => onChange(selectedDate)}
          options={{
            dateFormat: 'Y-m-d',
            allowInput: true,
            altInput: false, // Fixes double input issue
          }}
          className={`w-full bg-white text-[#143887] rounded-xl py-2 pl-4 pr-10 font-medium focus:ring-0 focus:outline-none shadow-sm placeholder:text-[#143887]/60 ${className}`}
          placeholder={placeholder}
        />
        <CalendarIcon className="w-5 h-5 text-[#143887] absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" />
      </div>
    </div>
  );
};

export default DatePicker;
